(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-product-media-gallery"] && !Shopify.designMode) return;
  try {
    class NewProductMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
  }

  connectedCallback() {
    // Wait for Swiper to be loaded
    if (typeof Swiper === 'undefined') {
      // If Swiper isn't loaded yet, wait for it
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          this.initSwipers();
        }
      }, 50);
    } else {
      this.initSwipers();
    }
  }

  disconnectedCallback() {
    // Cleanup Swiper instances when element is removed
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
    }
  }

  initSwipers() {
    const sectionId = this.dataset.sectionId;
    const mainSwiperEl = this.querySelector(`#MainSwiper-${sectionId}`);
    const thumbsSwiperEl = this.querySelector(`#ThumbsSwiper-${sectionId}`);
    const thumbPrevBtn = this.querySelector('.new-gallery__thumb-nav--prev');
    const thumbNextBtn = this.querySelector('.new-gallery__thumb-nav--next');

    if (!mainSwiperEl) {
      console.warn('Main swiper element not found');
      return;
    }

    // Initialize Thumbs Swiper first (if exists)
    if (thumbsSwiperEl) {
      this.thumbsSwiper = new Swiper(thumbsSwiperEl, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          990: {
            spaceBetween: 18
          }
        }
      });

      // Custom navigation for thumbnails
      if (thumbPrevBtn) {
        thumbPrevBtn.addEventListener('click', () => {
          this.thumbsSwiper.slidePrev();
        });
      }

      if (thumbNextBtn) {
        thumbNextBtn.addEventListener('click', () => {
          this.thumbsSwiper.slideNext();
        });
      }

      // Update thumb nav button states
      this.updateThumbNavState();
      this.thumbsSwiper.on('slideChange', () => this.updateThumbNavState());
      this.thumbsSwiper.on('reachBeginning', () => this.updateThumbNavState());
      this.thumbsSwiper.on('reachEnd', () => this.updateThumbNavState());
    }

    // Initialize Main Swiper with thumbs connection
    const mainSwiperConfig = {
      spaceBetween: 10,
      grabCursor: true,
      navigation: {
        nextEl: mainSwiperEl.querySelector('.swiper-button-next'),
        prevEl: mainSwiperEl.querySelector('.swiper-button-prev')
      }
    };

    // Connect thumbs if available
    if (this.thumbsSwiper) {
      mainSwiperConfig.thumbs = {
        swiper: this.thumbsSwiper,
        autoScrollOffset: 1
      };
    }

    this.mainSwiper = new Swiper(mainSwiperEl, mainSwiperConfig);

    // Sync main swiper changes to thumbs visibility
    if (this.thumbsSwiper) {
      this.mainSwiper.on('slideChange', () => {
        const activeIndex = this.mainSwiper.activeIndex;
        this.thumbsSwiper.slideTo(activeIndex);
        this.updateThumbNavState();
      });
    }
  }

  updateThumbNavState() {
    if (!this.thumbsSwiper) return;

    const thumbPrevBtn = this.querySelector('.new-gallery__thumb-nav--prev');
    const thumbNextBtn = this.querySelector('.new-gallery__thumb-nav--next');

    if (thumbPrevBtn) {
      thumbPrevBtn.disabled = this.thumbsSwiper.isBeginning;
    }

    if (thumbNextBtn) {
      thumbNextBtn.disabled = this.thumbsSwiper.isEnd;
    }
  }
}

if (!customElements.get('new-product-media-gallery')) {
  customElements.define('new-product-media-gallery', NewProductMediaGallery);
}
  } catch(e) { console.error(e); }
})();

})();
